







import Vue from "vue";

export default Vue.extend({
  name: "ReceiptDialogData",
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String || Number,
      default: null,
    },
  },
});
